import React from 'react';

export const RangeSlider = ({ min, max, value, ...rest }) => {
  return (
    <div className="range-slider">
      <div className="range">
        <input type="range" className="slider" min={min} max={max} {...rest}/>
        <span className="slider-value text-01-sky-blue-bold">{value}</span>
      </div>
      <div className="range-values">
        <span className="text-05-navy-blue">{min}</span>
        <span className="text-05-navy-blue">{max}</span>
      </div>
    </div>
  )
}